import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectHeadroomIsForced, showHeadroom, hideHeadroom } from '../components/scroll/ducks/index.js';

export default function useForcePinMobileNavbar() {
	const dispatch = useDispatch();

	const navbarIsForced = useSelector(selectHeadroomIsForced);

	const toggleForcePinHeadroom = useCallback(() => {
		if (!navbarIsForced) {
			dispatch(showHeadroom());
		} else {
			dispatch(hideHeadroom());
		}
	}, [dispatch, navbarIsForced]);
	const forcePinHeadroom = useCallback(() => dispatch(showHeadroom()), [dispatch]);
	const unforcePinHeadroom = useCallback(() => dispatch(hideHeadroom()), [dispatch]);

	return {
		toggleForcePinHeadroom,
		forcePinHeadroom,
		unforcePinHeadroom,
		navbarIsForced
	};
}
